import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import nhpStartBg from "@img/calculator/embed/corporate_loan/nhp.png";
import { List } from "bm-ui-kit";
import type { FormApi } from "final-form";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface StepFields {}

interface Props extends AbstractStepProps {
	koList: ReactNode[];
}

export class StepKo extends AbstractStep<StepFields, Props> {
	protected renderContent(_values: StepFields, _form: FormApi<StepFields>): ReactNode {
		return (
			<>
				<img src={nhpStartBg} alt="NHP" width={360} height={222} loading="lazy" />
				<Card.Header className="card-header-danger">
					<div className="card-title h4 text-center">Nincs jó hírünk</div>
				</Card.Header>
				<Card.Body>{this.renderKoList()}</Card.Body>
			</>
		);
	}

	private renderKoList(): ReactNode {
		const { koList = ["Váratlan hiba történt!"] } = this.props;
		const error =
			koList?.length === 1
				? koList[0]
				: "Sajnáljuk, de céged nem alkalmas hitelfelvételre, több szempontból sem.";

		return (
			<List itemStyle="warning-triangle" className="my-3 alert alert-danger">
				<List.Item>{error}</List.Item>
			</List>
		);
	}

	protected getComponentName(): string {
		return "StepKo";
	}
}
